/* eslint react/prop-types: [2, { ignore: ["classes", "options", "onNativeChange"] }] */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from '../../utils/isRequiredIf';
import Button from '../../buttons/Button';
import FormElement, { removeNonStandardProps as removeFormElementProps } from '../FormElement';
import Trigger, { removeNonStandardProps as removeTriggerProps } from '../../containers/Trigger';
import MultiSelectDropDownMenu, { removeNonStandardProps as removeMenuProps }
  from './MultiSelectDropDownMenu';
import { select, resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../../utils/removeKeys';

/**
MultiSelect Component
**/
export class MultiSelectDropDown extends React.Component {
  static displayName = 'MultiSelectDropDown';
  static propTypes = {
    ...FormElement.propTypes,
    /** Callback function who's return value is used as the selected text to display. */
    selectedTextCallback: PropTypes.func.isRequired,
    /** When to break down to 100% width */
    breakPoint: PropTypes.oneOf(['mediaSmall', 'mediaMedium', 'mediaLarge', 'mediaAll']),
    /** Text for inline label for multi select dropdown */
    inlineLabel: PropTypes.string,
    /** Element that will display inside the dropdown button after any label text. */
    inlineElement: PropTypes.element,
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Style object applied to the Trigger component. */
      trigger: PropTypes.object,
      /** Style object applied to the MultiSelectDropDownMenu component. */
      menu: PropTypes.object,
      /** Style object applied to the Button component. */
      button: PropTypes.object
    }),
    /** for react-redux-form support */
    selectedValues: isRequiredIf(PropTypes.array, (props) => props.hasOwnProperty('onNativeChange'))
  };
  static defaultProps = {
    allowMouse: false
  };
  constructor(props) {
    super(props);
    this.getSelectedText = this.getSelectedText.bind(this);
  }
  /**
   * Determines what text to display according to the currently selected options.
   */
  getSelectedText() {
    const selectedValues = [];
    const isNucleusField = this.props.hasOwnProperty('onNativeChange') && this.props.hasOwnProperty('selectedValues');
    if (this.props.inlineLabel) {
      return this.props.inlineLabel;
    }
    if (this.props.options.hasOwnProperty('selectedValues')) {
      this.props.options.optionArray.forEach((option) => {
        if (this.props.options.selectedValues.indexOf(option.value) >= 0) {
          selectedValues.push(option.name);
        }
      });
    } else if (this.props.options.length && this.props.options[0].hasOwnProperty('category')) {
      this.props.options.forEach((category) => {
        category.items.forEach((option) => {
          if (isNucleusField) {
            if (this.props.selectedValues.indexOf(option.value) !== -1) {
              selectedValues.push(option.name);
            }
          } else if (option.checked) {
            selectedValues.push(option.name);
          }
        });
      });
    } else {
      this.props.options.forEach((option) => {
        if (isNucleusField) {
          if (this.props.selectedValues.indexOf(option.value) !== -1) {
            selectedValues.push(option.name);
          }
        } if (option.checked) {
          selectedValues.push(option.name);
        }
      });
    }
    switch (selectedValues.length) {
      case 1:
        return selectedValues[0];
      case 0:
        return '';
      default:
        return this.props.selectedTextCallback(selectedValues.length);
    }
  }
  render() {
    const { classes, breakPoint, ...rest } = removeKeys(this.props, ['selectedTextCallback']);
    return (
      <Trigger {...this.props} {...select(this.props, 'trigger')}>
        <Button {...removeFormElementProps(removeMenuProps(removeTriggerProps(rest)))}
          classes={classes}
          breakPoint={breakPoint}
          {...resolve(this.props, 'button', breakPoint)}
        >
          {this.getSelectedText()}
          {this.props.inlineElement}
        </Button>
        <MultiSelectDropDownMenu {...this.props}
          {...select(this.props, 'menu')} />
      </Trigger>
    );
  }
}

/**
FormElement wrapper around MultiSelectDropDown. This is the default export.
**/
const MultiSelectDropDownFormElement = (props) => {
  const { children, ...rest } = props;
  return (
    <FormElement {...rest}>
      <MultiSelectDropDown {...rest} {...select(props, 'multiselect')} />
      {children}
    </FormElement>
  );
};
MultiSelectDropDownFormElement.propTypes = {
  /** The child content to display after the MultiSelectDropDown. */
  children: PropTypes.node,
  /** When to break down to 100% width */
  breakPoint: PropTypes.oneOf(['mediaSmall', 'mediaMedium', 'mediaLarge', 'mediaAll']),
  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Style object applied to the MultiSelectDropDown component. */
    multiselect: PropTypes.object
  })
};
MultiSelectDropDownFormElement.displayName = 'MultiSelectDropDownFormElement';

export default MultiSelectDropDownFormElement;
